import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	name: {
		id: 'admin-pages-performance.common.assets.custom-fields.name',
		defaultMessage: 'Custom fields',
		description:
			'Name of the site optimizer metric that will be used as the title on the page and menu item.',
	},
	description: {
		id: 'admin-pages-performance.common.assets.custom-fields.description',
		defaultMessage:
			'Here are the custom fields in your site, including ones we think can be removed because they’re not used. Removing unused fields could improve site performance and stability.',
		description: 'Description of the site optimizer metric.',
	},
	descriptionV2: {
		id: 'admin-pages__performance.common.assets.custom-fields.description-v-2',
		defaultMessage:
			'Monitor custom field usage across projects. Each project can have up to 700 custom fields per scheme track usage to stay within this threshold and prevent performance degradation or configuration blocks.',
		description: 'Description of the site optimizer metric.',
	},
	chart: {
		id: 'admin-pages-performance.common.assets.custom-fields.chart',
		defaultMessage: 'Overview',
		description: 'A tab label of Custom Field Tabs, to show custom fields chart',
	},
	reviewAndAnalyze: {
		id: 'admin-pages-performance.common.assets.custom-fields.review-and-analyze',
		defaultMessage: 'Analysis',
		description: 'A tab label of Custom Field Tabs, to show custom fields review and analyze',
	},
	warning: {
		id: 'admin-pages-performance.common.assets.custom-fields.warning',
		defaultMessage: 'The number of custom fields is nearing our recommended threshold.',
		description: 'Warning message if metric are getting close to the threshold.',
	},
	exceeded: {
		id: 'admin-pages-performance.common.assets.custom-fields.exceeded',
		defaultMessage: 'There are more custom fields than our recommended threshold.',
		description: 'Message to show to the user if metric has exceeded the threshold.',
	},
	risk1: {
		id: 'admin-pages-performance.common.assets.custom-fields.risk-1',
		defaultMessage:
			'Custom fields can make searching for issues (JQL and boards) and creating issues slow.',
		description: 'One of the risks when this metric exceeded the threshold.',
	},
	mitigation1: {
		id: 'admin-pages-performance.common.assets.custom-fields.mitigation-1',
		defaultMessage:
			'Edit the context for the custom field to make it visible only for specific projects.',
		description: 'One of the mitigation options when this metric exceeded the threshold.',
	},
	mitigation2: {
		id: 'admin-pages-performance.common.assets.custom-fields.mitigation-2',
		defaultMessage:
			'Limit the number of custom fields across all projects and use the same custom field in multiple projects.',
		description: 'One of the mitigation options when this metric exceeded the threshold.',
	},
	currentValueLabel: {
		id: 'admin-pages-performance.common.assets.custom-fields.current-value-label',
		defaultMessage: 'Custom fields in your site',
		description: 'Label to be shown next to the current value of the metric.',
	},
	thresholdValueLabel: {
		id: 'admin-pages-performance.common.assets.custom-fields.threshold-value-label',
		defaultMessage: 'Recommended maximum number of custom fields',
		description: 'Label to be shown next to the threshold value of the metric.',
	},
	globalScopedCustomFieldsCountLabel: {
		id: 'admin-pages-performance.common.assets.custom-fields.global-scoped-custom-fields-count-label',
		defaultMessage: 'CMP custom fields count',
		description: 'Label to be shown next to the global scoped custom fields count',
	},
	projectScopedCustomFieldsCountLabel: {
		id: 'admin-pages-performance.common.assets.custom-fields.project-scoped-custom-fields-count-label',
		defaultMessage: 'TMP custom fields count',
		description: 'Label to be shown next to the project scoped custom fields count',
	},
	currentValueAriaLabel: {
		id: 'admin-pages-performance.common.assets.custom-fields.current-value-aria-label',
		defaultMessage: '{number} custom fields in your site',
		description: 'Aria Label for the current value',
	},
	thresholdValueAriaLabel: {
		id: 'admin-pages-performance.common.assets.custom-fields.threshold-value-aria-label',
		defaultMessage: '{number} recommended maximum number of custom fields',
		description: 'Aria Label for the threshold value',
	},
	globalScopedCustomFieldsCountAriaLabel: {
		id: 'admin-pages-performance.common.assets.custom-fields.global-scoped-custom-fields-count-aria-label',
		defaultMessage:
			'{number} {number, plural, one {global scoped custom field} other {global scoped custom fields}}',
		description: 'Aria Label for the global scoped custom fields count',
	},
	projectScopedCustomFieldsCountAriaLabel: {
		id: 'admin-pages-performance.common.assets.custom-fields.project-scoped-custom-fields-count-aria-label',
		defaultMessage:
			'{number} {number, plural, one {project scoped custom field} other {global scoped custom fields}}',
		description: 'Aria Label for the project scoped custom fields count',
	},
	recommendationUrlText: {
		id: 'admin-pages-performance.common.assets.custom-fields.recommendation-url-text',
		defaultMessage: 'See how we identify these fields.',
		description: 'Text to be shown on the hypertext link to additional documentation.',
	},
	recommendationUrlTextV2: {
		id: 'admin-pages__performance.common.assets.custom-fields.recommendation-url-text-v-2',
		defaultMessage: 'Learn how we identify these fields.',
		description: 'Text to be shown on the hypertext link to additional documentation.',
	},
	graphHeader: {
		id: 'admin-pages-performance.common.assets.custom-fields.graph-header',
		defaultMessage: 'Custom fields over time',
		description: 'Text to be shown on the header of the metric graph.',
	},
	risk1IssueTermRefresh: {
		id: 'admin-pages-performance.common.assets.custom-fields.risk-1-issue-term-refresh',
		defaultMessage:
			'Custom fields can make searching (JQL and boards) and creating work items slow.',
		description: 'One of the risks when this metric exceeded the threshold.',
	},
});
